/**
 * MACIRI DONIA — Luxury Product Page
 * Gallery slider, variant picker, recommendations carousel (vanilla JS).
 */
(function () {
  'use strict';

  var SWIPE_THRESHOLD = 48;
  var DRAG_CLICK_THRESHOLD = 6;
  var RESUME_DELAY = 5000;

  /* ── Product gallery slider ─────────────────────────────────── */

  function ProductGallerySlider(slider) {
    this.slider = slider;
    this.track = slider.querySelector('.product-image-track');
    this.slides = this.track
      ? Array.prototype.slice.call(this.track.querySelectorAll('.product-image-slide'))
      : [];
    this.dotsContainer = slider.querySelector('[data-slider-dots]');
    this.prevBtn = slider.querySelector('[data-slider-prev]');
    this.nextBtn = slider.querySelector('[data-slider-next]');

    if (!this.track || this.slides.length < 2) return;

    this.index = 0;
    this.isDragging = false;
    this.startX = 0;
    this.currentX = 0;

    this.buildDots();
    this.bindEvents();
    this.updateUI();
  }

  ProductGallerySlider.prototype.buildDots = function () {
    var self = this;
    if (!this.dotsContainer) return;

    this.dotsContainer.innerHTML = '';
    this.slides.forEach(function (_, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'slider-dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Go to image ' + (i + 1));
      dot.addEventListener('click', function () {
        self.goTo(i);
      });
      self.dotsContainer.appendChild(dot);
    });
  };

  ProductGallerySlider.prototype.updateUI = function () {
    var index = this.index;
    this.track.style.transform = 'translate3d(-' + index * 100 + '%, 0, 0)';

    if (this.dotsContainer) {
      var dots = this.dotsContainer.querySelectorAll('.slider-dot');
      Array.prototype.forEach.call(dots, function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }
  };

  ProductGallerySlider.prototype.goTo = function (i) {
    this.index = (i + this.slides.length) % this.slides.length;
    this.updateUI();
  };

  ProductGallerySlider.prototype.bindEvents = function () {
    var self = this;

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', function () {
        self.goTo(self.index - 1);
      });
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', function () {
        self.goTo(self.index + 1);
      });
    }

    this.slider.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        self.goTo(self.index - 1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        self.goTo(self.index + 1);
      }
    });

    this.onPointerDown = function (clientX) {
      self.isDragging = true;
      self.startX = clientX;
      self.currentX = clientX;
      self.slider.classList.add('is-dragging');
    };

    this.onPointerMove = function (clientX) {
      if (!self.isDragging) return;
      self.currentX = clientX;
      var delta = self.currentX - self.startX;
      var offset = -self.index * 100 + (delta / self.slider.offsetWidth) * 100;
      self.track.style.transform = 'translate3d(' + offset + '%, 0, 0)';
    };

    this.onPointerUp = function () {
      if (!self.isDragging) return;
      var delta = self.currentX - self.startX;
      self.isDragging = false;
      self.slider.classList.remove('is-dragging');

      if (Math.abs(delta) > SWIPE_THRESHOLD) {
        if (delta < 0) self.goTo(self.index + 1);
        else self.goTo(self.index - 1);
      } else {
        self.updateUI();
      }
    };

    this.slider.addEventListener(
      'touchstart',
      function (e) {
        self.onPointerDown(e.touches[0].clientX);
      },
      { passive: true }
    );

    this.slider.addEventListener(
      'touchmove',
      function (e) {
        self.onPointerMove(e.touches[0].clientX);
      },
      { passive: true }
    );

    this.slider.addEventListener(
      'touchend',
      function () {
        self.onPointerUp();
      },
      { passive: true }
    );

    this.slider.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      e.preventDefault();
      self.onPointerDown(e.clientX);

      function onMouseMove(ev) {
        self.onPointerMove(ev.clientX);
      }

      function onMouseUp() {
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
        self.onPointerUp();
      }

      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
    });
  };

  /* ── Delivery accordion ─────────────────────────────────────── */

  function initDeliveryAccordions(scope) {
    var wraps = (scope || document).querySelectorAll('[data-delivery-accordion]');

    Array.prototype.forEach.call(wraps, function (wrap) {
      if (wrap.__deliveryBound) return;
      wrap.__deliveryBound = true;

      var toggle = wrap.querySelector('[data-delivery-toggle]');
      var panel = wrap.querySelector('[data-delivery-panel]');
      if (!toggle || !panel) return;

      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        panel.hidden = isOpen;
      });
    });
  }

  /* ── Variant picker ─────────────────────────────────────────── */

  function initVariantPicker(scope) {
    var root = scope || document;
    var form = root.querySelector('#product-main-form');
    var variantsJson = root.querySelector('#product-main-variants');
    if (!form || !variantsJson) return;

    var variants = JSON.parse(variantsJson.textContent);
    var idInput = form.querySelector('[data-variant-id]');
    var priceValueEl = form.querySelector('[data-price-value]');
    var compareEl = form.querySelector('[data-price-compare]');
    var soldOutLabelEl = form.querySelector('[data-sold-out-label]');
    var addBtn = form.querySelector('[data-add-to-cart]');
    var selects = form.querySelectorAll('[data-option-index]');

    function getSelectedOptions() {
      return Array.prototype.map.call(selects, function (s) {
        return s.value;
      });
    }

    function findVariant() {
      var selected = getSelectedOptions();
      return variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return opt === selected[i];
        });
      });
    }

    function formatMoney(cents) {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents);
      }
      return '$' + (cents / 100).toFixed(2);
    }

    function isVariantPurchasable(variant) {
      return !!(variant && variant.available);
    }

    function onVariantChange() {
      var variant = findVariant();
      if (!variant) return;

      var purchasable = isVariantPurchasable(variant);

      if (idInput) idInput.value = variant.id;

      if (priceValueEl) {
        priceValueEl.textContent = formatMoney(variant.price);
      }

      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      if (soldOutLabelEl) {
        soldOutLabelEl.hidden = purchasable;
      }

      if (addBtn) {
        addBtn.disabled = !purchasable;
        addBtn.textContent = purchasable ? addBtn.dataset.labelAdd || 'Add to Cart' : 'Sold Out';
      }
    }

    form.addEventListener('submit', function (e) {
      var variant = findVariant();
      if (!isVariantPurchasable(variant)) {
        e.preventDefault();
      }
    });

    Array.prototype.forEach.call(selects, function (select) {
      select.addEventListener('change', onVariantChange);
    });
  }

  /* ── Recommendations carousel ───────────────────────────────── */

  function ProductRecsCarousel(root) {
    this.root = root;
    this.viewport = root.querySelector('[data-recs-viewport]');
    this.track = root.querySelector('[data-recs-track]');
    this.prevBtn = root.querySelector('[data-recs-prev]');
    this.nextBtn = root.querySelector('[data-recs-next]');
    this.dotsContainer = root.querySelector('[data-recs-dots]');

    if (!this.viewport || !this.track) return;

    this.config = {
      autoplay: root.dataset.autoplay !== 'false',
      autoplaySpeed: parseInt(root.dataset.autoplaySpeed, 10) || 4000,
      showArrows: root.dataset.showArrows !== 'false',
      showDots: root.dataset.showDots !== 'false',
      hoverZoom: root.dataset.hoverZoom !== 'false',
      showQuickAdd: root.dataset.showQuickAdd === 'true',
      quickAddLabel: root.dataset.quickAddLabel || 'Quick Add',
      moneyFormat: root.dataset.moneyFormat || '${{amount}}'
    };

    this.realSlides = [];
    this.allSlides = [];
    this.realCount = 0;
    this.index = 0;
    this.visualIndex = 1;
    this.slideWidth = 0;
    this.gap = 0;
    this.isDragging = false;
    this.didDrag = false;
    this.startX = 0;
    this.currentX = 0;
    this.autoplayTimer = null;
    this.resumeTimer = null;
    this.isPaused = false;
    this.isHovered = false;
    this.isTouching = false;
    this.transitioning = false;

    this.loadProducts();
  }

  ProductRecsCarousel.prototype.normalizeProduct = function (p) {
    var images = [];
    if (p.images && p.images.length) {
      p.images.forEach(function (img) {
        images.push(typeof img === 'string' ? img : img.src);
      });
    }

    var featured =
      typeof p.featured_image === 'string'
        ? p.featured_image
        : p.featured_image && p.featured_image.src
          ? p.featured_image.src
          : images[0] || null;

    return {
      id: p.id,
      title: p.title,
      url: p.url || '/products/' + p.handle,
      price: p.price,
      compare_at_price: p.compare_at_price,
      available: p.available !== false,
      variants: p.variants || [],
      featured_image: featured,
      images: images
    };
  };

  ProductRecsCarousel.prototype.formatMoney = function (cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, this.config.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  };

  ProductRecsCarousel.prototype.isSoldOut = function (product) {
    if (product.available === false) return true;
    if (product.variants && product.variants.length) {
      return !product.variants.some(function (v) {
        return v.available;
      });
    }
    return false;
  };

  ProductRecsCarousel.prototype.getFirstAvailableVariant = function (product) {
    if (!product.variants) return null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) return product.variants[i];
    }
    return product.variants[0] || null;
  };

  ProductRecsCarousel.prototype.buildCardHTML = function (product) {
    var soldOut = this.isSoldOut(product);
    var variant = this.getFirstAvailableVariant(product);
    var onSale = product.compare_at_price && product.compare_at_price > product.price;
    var primaryImg = product.featured_image || (product.images && product.images[0]) || null;
    var hoverImg = product.images && product.images.length > 1 ? product.images[1] : null;
    var hasHover = !!hoverImg;
    var zoomClass = this.config.hoverZoom ? ' product-rec-card--zoom' : '';
    var hoverClass = hasHover ? ' product-rec-card--has-hover' : '';

    var html =
      '<article class="product-rec-card' +
      zoomClass +
      hoverClass +
      (soldOut ? ' product-rec-card--sold-out' : '') +
      '">' +
      '<div class="product-rec-card__media">';

    if (soldOut) {
      html += '<span class="product-rec-card__badge">Sold Out</span>';
    }

    html +=
      '<a href="' +
      product.url +
      '" class="product-rec-card__media-link" tabindex="-1" aria-hidden="true">' +
      '<div class="product-rec-card__image-wrap">';

    if (primaryImg) {
      html +=
        '<img class="product-rec-card__image product-rec-card__image--primary" ' +
        'src="' +
        primaryImg +
        '" alt="' +
        this.escapeHtml(product.title) +
        '" loading="lazy" decoding="async" width="600" height="800">';
    }

    if (hoverImg) {
      html +=
        '<img class="product-rec-card__image product-rec-card__image--hover" ' +
        'src="' +
        hoverImg +
        '" alt="" loading="lazy" decoding="async" width="600" height="800" aria-hidden="true">';
    }

    html += '</div></a></div><div class="product-rec-card__body">';
    html +=
      '<h3 class="product-rec-card__title"><a href="' +
      product.url +
      '" class="product-rec-card__title-link">' +
      this.escapeHtml(product.title) +
      '</a></h3>';
    html += '<p class="product-rec-card__price">';

    if (onSale) {
      html +=
        '<span class="product-rec-card__price-sale">' +
        this.formatMoney(product.price) +
        '</span>' +
        '<span class="product-rec-card__price-compare"><s>' +
        this.formatMoney(product.compare_at_price) +
        '</s></span>';
    } else {
      html += '<span>' + this.formatMoney(product.price) + '</span>';
    }

    html += '</p>';

    if (this.config.showQuickAdd && !soldOut && variant) {
      html +=
        '<form class="product-rec-card__quick-add" method="post" action="/cart/add" data-quick-add>' +
        '<input type="hidden" name="id" value="' +
        variant.id +
        '">' +
        '<button type="submit" name="add" class="product-rec-card__quick-add-btn">' +
        this.escapeHtml(this.config.quickAddLabel) +
        '</button></form>';
    }

    html += '</div></article>';
    return html;
  };

  ProductRecsCarousel.prototype.escapeHtml = function (str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  };

  ProductRecsCarousel.prototype.loadProducts = function () {
    var self = this;
    var productId = this.root.dataset.productId;
    var limit = parseInt(this.root.dataset.limit, 10) || 8;
    var collectionHandle = this.root.dataset.collection;
    var loadingEl = this.root.querySelector('[data-recs-loading]');
    var emptyEl = this.root.querySelector('[data-recs-empty]');

    function onProducts(products) {
      if (loadingEl) loadingEl.hidden = true;

      products = (products || []).map(function (p) {
        return self.normalizeProduct(p);
      });

      if (!products.length) {
        if (emptyEl) emptyEl.hidden = false;
        self.root.hidden = true;
        return;
      }

      self.root.hidden = false;
      self.track.innerHTML = products
        .map(function (p) {
          return (
            '<div class="product-recs__slide" data-recs-slide role="group" aria-roledescription="slide">' +
            self.buildCardHTML(p) +
            '</div>'
          );
        })
        .join('');

      self.initQuickAdd();
      self.setupCarousel();
    }

    if (collectionHandle) {
      fetch('/collections/' + collectionHandle + '/products.json?limit=' + limit)
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          var products = (data.products || []).filter(function (p) {
            return String(p.id) !== String(productId);
          });
          onProducts(products.slice(0, limit));
        })
        .catch(function () {
          if (loadingEl) loadingEl.hidden = true;
          self.root.hidden = true;
        });
      return;
    }

    var url =
      (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') +
      'recommendations/products.json?product_id=' +
      productId +
      '&limit=' +
      limit;

    fetch(url)
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        onProducts(data.products || []);
      })
      .catch(function () {
        if (loadingEl) loadingEl.hidden = true;
        self.root.hidden = true;
      });
  };

  ProductRecsCarousel.prototype.initQuickAdd = function () {
    var forms = this.root.querySelectorAll('[data-quick-add]');
    Array.prototype.forEach.call(forms, function (form) {
      if (form.__quickAddBound) return;
      form.__quickAddBound = true;
      form.addEventListener('submit', function () {
        var btn = form.querySelector('.product-rec-card__quick-add-btn');
        if (btn) btn.classList.add('is-loading');
      });
      form.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    });
  };

  ProductRecsCarousel.prototype.setupCarousel = function () {
    this.realSlides = Array.prototype.slice.call(this.track.querySelectorAll('[data-recs-slide]'));
    this.realCount = this.realSlides.length;

    if (this.realCount < 1) {
      this.root.hidden = true;
      return;
    }

    this.visualIndex = this.realCount >= 2 ? 1 : 0;

    if (this.realCount >= 2) {
      this.setupInfinite();
    }

    this.allSlides = Array.prototype.slice.call(
      this.track.querySelectorAll('[data-recs-slide], [data-recs-clone]')
    );

    this.measure();
    this.buildDots();
    this.bindCarouselEvents();
    this.updateUI(false);
    this.startAutoplay();

    var self = this;
    window.addEventListener('resize', function () {
      self.measure();
      self.updateUI(false);
    });
  };

  ProductRecsCarousel.prototype.setupInfinite = function () {
    var firstClone = this.realSlides[0].cloneNode(true);
    var lastClone = this.realSlides[this.realCount - 1].cloneNode(true);

    firstClone.setAttribute('data-recs-clone', 'first');
    lastClone.setAttribute('data-recs-clone', 'last');
    firstClone.setAttribute('aria-hidden', 'true');

    var cloneImgs = firstClone.querySelectorAll('img');
    Array.prototype.forEach.call(cloneImgs, function (img) {
      img.loading = 'lazy';
    });
    cloneImgs = lastClone.querySelectorAll('img');
    Array.prototype.forEach.call(cloneImgs, function (img) {
      img.loading = 'lazy';
    });

    this.track.insertBefore(lastClone, this.realSlides[0]);
    this.track.appendChild(firstClone);
  };

  ProductRecsCarousel.prototype.measure = function () {
    if (!this.allSlides.length) return;
    var style = window.getComputedStyle(this.track);
    this.gap = parseFloat(style.gap) || 0;
    this.slideWidth = this.allSlides[0].offsetWidth + this.gap;
  };

  ProductRecsCarousel.prototype.getOffset = function () {
    return -this.visualIndex * this.slideWidth;
  };

  ProductRecsCarousel.prototype.updateUI = function (animate) {
    if (animate === false) {
      this.track.style.transition = 'none';
    }
    this.track.style.transform = 'translate3d(' + this.getOffset() + 'px, 0, 0)';
    if (animate === false) {
      void this.track.offsetWidth;
      this.track.style.transition = '';
    }

    if (this.dotsContainer) {
      var dots = this.dotsContainer.querySelectorAll('.product-recs__dot');
      var self = this;
      Array.prototype.forEach.call(dots, function (dot, i) {
        var active = i === self.index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }
  };

  ProductRecsCarousel.prototype.normalizeIndex = function () {
    if (this.realCount < 2) return;

    if (this.visualIndex === 0) {
      this.visualIndex = this.realCount;
      this.index = this.realCount - 1;
      this.updateUI(false);
    } else if (this.visualIndex === this.realCount + 1) {
      this.visualIndex = 1;
      this.index = 0;
      this.updateUI(false);
    }
  };

  ProductRecsCarousel.prototype.goTo = function (targetIndex, direction) {
    if (this.realCount < 2) return;
    if (this.transitioning && !this.isDragging) return;

    var prev = this.index;
    this.index = (targetIndex + this.realCount) % this.realCount;

    if (direction === 'next' || (direction == null && targetIndex === prev + 1)) {
      this.visualIndex += 1;
    } else if (direction === 'prev' || (direction == null && targetIndex === prev - 1)) {
      this.visualIndex -= 1;
    } else {
      this.visualIndex = this.index + 1;
    }

    this.transitioning = true;
    this.updateUI(true);
  };

  ProductRecsCarousel.prototype.next = function () {
    this.goTo(this.index + 1, 'next');
  };

  ProductRecsCarousel.prototype.prev = function () {
    this.goTo(this.index - 1, 'prev');
  };

  ProductRecsCarousel.prototype.buildDots = function () {
    if (!this.config.showDots || !this.dotsContainer || this.realCount < 2) return;

    this.dotsContainer.innerHTML = '';
    var self = this;

    for (var i = 0; i < this.realCount; i++) {
      (function (dotIndex) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'product-recs__dot' + (dotIndex === 0 ? ' is-active' : '');
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Go to slide ' + (dotIndex + 1));
        dot.setAttribute('aria-selected', dotIndex === 0 ? 'true' : 'false');
        dot.addEventListener('click', function () {
          self.goTo(dotIndex);
          self.pauseAndScheduleResume();
        });
        self.dotsContainer.appendChild(dot);
      })(i);
    }
  };

  ProductRecsCarousel.prototype.clearAutoplay = function () {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  };

  ProductRecsCarousel.prototype.clearResume = function () {
    if (this.resumeTimer) {
      clearTimeout(this.resumeTimer);
      this.resumeTimer = null;
    }
  };

  ProductRecsCarousel.prototype.startAutoplay = function () {
    var self = this;
    this.clearAutoplay();

    if (
      !this.config.autoplay ||
      this.realCount < 2 ||
      this.isPaused ||
      this.isHovered ||
      this.isTouching ||
      this.isDragging
    ) {
      return;
    }

    this.autoplayTimer = setInterval(function () {
      if (!self.isPaused && !self.isHovered && !self.isTouching && !self.isDragging) {
        self.next();
      }
    }, this.config.autoplaySpeed);
  };

  ProductRecsCarousel.prototype.pauseAndScheduleResume = function () {
    var self = this;
    this.isPaused = true;
    this.clearAutoplay();
    this.clearResume();

    this.resumeTimer = setTimeout(function () {
      self.isPaused = false;
      if (!self.isHovered && !self.isTouching && !self.isDragging) {
        self.startAutoplay();
      }
    }, RESUME_DELAY);
  };

  ProductRecsCarousel.prototype.onPointerDown = function (clientX) {
    if (this.realCount < 2) return;
    this.isDragging = true;
    this.didDrag = false;
    this.startX = clientX;
    this.currentX = clientX;
    this.viewport.classList.add('is-dragging');
    this.pauseAndScheduleResume();
  };

  ProductRecsCarousel.prototype.onPointerMove = function (clientX) {
    if (!this.isDragging) return;

    this.currentX = clientX;
    var delta = this.currentX - this.startX;

    if (Math.abs(delta) > DRAG_CLICK_THRESHOLD) {
      this.didDrag = true;
    }

    var offset = this.getOffset() + delta;
    this.track.style.transform = 'translate3d(' + offset + 'px, 0, 0)';
  };

  ProductRecsCarousel.prototype.onPointerUp = function () {
    if (!this.isDragging) return;

    var delta = this.currentX - this.startX;
    this.isDragging = false;
    this.viewport.classList.remove('is-dragging');

    if (Math.abs(delta) > SWIPE_THRESHOLD) {
      if (delta < 0) this.next();
      else this.prev();
    } else {
      this.updateUI(true);
    }

    var self = this;
    setTimeout(function () {
      self.didDrag = false;
    }, 0);
  };

  ProductRecsCarousel.prototype.bindCarouselEvents = function () {
    var self = this;

    if (this.prevBtn) {
      this.prevBtn.hidden = !this.config.showArrows;
      this.prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        self.prev();
        self.pauseAndScheduleResume();
      });
    }

    if (this.nextBtn) {
      this.nextBtn.hidden = !this.config.showArrows;
      this.nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        self.next();
        self.pauseAndScheduleResume();
      });
    }

    this.track.addEventListener('transitionend', function (e) {
      if (e.target !== self.track) return;
      self.transitioning = false;
      self.normalizeIndex();
    });

    this.root.addEventListener('mouseenter', function () {
      self.isHovered = true;
      self.isPaused = true;
      self.clearAutoplay();
      self.clearResume();
    });

    this.root.addEventListener('mouseleave', function () {
      self.isHovered = false;
      self.clearResume();
      self.resumeTimer = setTimeout(function () {
        self.isPaused = false;
        if (!self.isTouching && !self.isDragging) {
          self.startAutoplay();
        }
      }, RESUME_DELAY);
    });

    this.viewport.addEventListener(
      'touchstart',
      function (e) {
        self.isTouching = true;
        self.pauseAndScheduleResume();
        self.onPointerDown(e.touches[0].clientX);
      },
      { passive: true }
    );

    this.viewport.addEventListener(
      'touchmove',
      function (e) {
        self.onPointerMove(e.touches[0].clientX);
      },
      { passive: true }
    );

    this.viewport.addEventListener(
      'touchend',
      function () {
        self.isTouching = false;
        self.onPointerUp();
      },
      { passive: true }
    );

    this.viewport.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      e.preventDefault();
      self.onPointerDown(e.clientX);

      function onMouseMove(ev) {
        self.onPointerMove(ev.clientX);
      }

      function onMouseUp() {
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
        self.onPointerUp();
      }

      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
    });

    this.root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        self.prev();
        self.pauseAndScheduleResume();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        self.next();
        self.pauseAndScheduleResume();
      }
    });

    this.viewport.addEventListener('click', function (e) {
      if (self.didDrag) {
        e.preventDefault();
        e.stopPropagation();
      }
    });
  };

  /* ── Init ───────────────────────────────────────────────────── */

  function initGallerySliders(scope) {
    var sliders = (scope || document).querySelectorAll('[data-product-slider]');
    Array.prototype.forEach.call(sliders, function (slider) {
      if (slider.__gallerySlider) return;
      var instance = new ProductGallerySlider(slider);
      if (instance.track) {
        slider.__gallerySlider = instance;
        slider.setAttribute('tabindex', '0');
        slider.setAttribute('role', 'region');
        slider.setAttribute('aria-roledescription', 'carousel');
        slider.setAttribute('aria-label', 'Product images');
      }
    });
  }

  function initRecsCarousels(scope) {
    var carousels = (scope || document).querySelectorAll('[data-product-recs]');
    Array.prototype.forEach.call(carousels, function (el) {
      if (el.__recsCarousel) return;
      el.__recsCarousel = new ProductRecsCarousel(el);
    });
  }

  function init(scope) {
    initGallerySliders(scope);
    initDeliveryAccordions(scope);
    initVariantPicker(scope);
    initRecsCarousels(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
